import { ReactNode } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { bindActionCreators, Dispatch } from "redux";
import logo from "../../assets/images/logo.png";
import wallet from "../../assets/images/wallet.svg";
import { MeDto } from "../../core/models/dtos/me.dto";
import FirebaseService from "../../core/services/firebaseService/firebase.service";
import { Constants } from "../../core/utilities/constants";
import { IStore } from "../../core/utilities/reducers";
import { router } from "../../core/utilities/router";
import cup from "../../assets/images/cup.svg";
import notific from "../../assets/images/notific.svg";
import "./AppHeader.scss";
import HumpCount from "./HumpCount/HumpCount";

interface IProps {
  me?: MeDto;
  pathname: string;
}

const AppHeader = (props: IProps) => {
  const isHumpCount = (): boolean => {
    return !!props.me && props.me.remainingHumpCount > 0;
  };

  function renderButtonLeaderboard(): ReactNode {
    return (
      <NavLink
        to={router.LEADERBOARD}
        className="wallet leaderboard"
        onClick={() =>
          FirebaseService.logEvent(
            FirebaseService.user_count_leaderboard_button_clicked
          )
        }
      >
        <img className="notification" src={notific} alt="notification" />
        <img src={cup} alt="cup" />
      </NavLink>
    );
  }

  function renderButtonWallet(): ReactNode {
    return (
      <a
        className="wallet"
        href={Constants.linkWallet}
        target="_blank"
        rel="noreferrer noopener"
        onClick={() =>
          FirebaseService.logEvent(FirebaseService.user_count_wallet_clicked, {
            newcomer: !props.me?.termsAcceptanceDate,
          })
        }
      >
        <img src={wallet} alt="wallet" />
      </a>
    );
  }

  function renderButtonSSS(): ReactNode {
    return (
      <NavLink to={router.FAQ} className="wallet sss">
        ?
      </NavLink>
    );
  }

  return (
    <div id="app-header">
      <div className="content">
        <div className="info">
          <div className="stamp-wrapper">
            <img className="logo" src={logo} alt="logo" />
            {isHumpCount() && (
              <HumpCount hump={props.me?.remainingHumpCount ?? 0} />
            )}
          </div>
        </div>
        <div className="buttons">
          {/* {renderButtonLeaderboard()} */}
          {renderButtonWallet()}
          {renderButtonSSS()}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({}, dispatch);
};
const mapStateToProps = (store: IStore) => {
  return {
    me: store.setMe.me,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AppHeader);
